import { effect, signal } from "@preact/signals-react";
import { PlayerControl, PlayingSong } from "stuen-common";

export const currentSongUniqueId = signal<string | null>(null); // Used to force reload of video element when two songs have the same url
export const currentSong = signal<PlayingSong | null>(null);
export const currentPlayerControl = signal<PlayerControl | null>(null);
export const currentSongPlayerMuted = signal<boolean>(false);

effect(() => {
  if (currentSong.value) {
    document.title = currentSong.value.title;
  } else {
    document.title = `Stuen`;
  }
});
